/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../simple_instrument_store/api';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "servicing": {
            "nested": {
              "instruments": {
                "nested": {
                  "models": {
                    "nested": {
                      "InstrumentSummary": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "isActive": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "bankAccountSummary": {
                            "type": ".squareup.capital.servicing.instruments.models.BankAccountSummary",
                            "id": 2
                          },
                          "cardSummary": {
                            "type": ".squareup.simple_instrument_store.api.CardSummary",
                            "id": 3
                          }
                        },
                        "nested": {
                          "summary_view": {
                            "oneof": ["bankAccountSummary", "cardSummary"]
                          }
                        }
                      },
                      "BankAccountSummary": {
                        "fields": {
                          "bankName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountNumberSuffix": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.instruments?.nested?.models?.nested?.InstrumentSummary && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.instruments?.nested?.models?.nested?.BankAccountSummary) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc InstrumentSummary is a simplified version of the Instrument model provided by
 * the simple_instrument_store package.
 * --
 *
 * SOURCE InstrumentSummary @ squareup/capital/servicing/instruments/models.proto at 15:1
 */
export const InstrumentSummary = $root.lookupType('squareup.capital.servicing.instruments.models.InstrumentSummary');
fixType(InstrumentSummary, {
  id: {
    required: true
  },
  isActive: {
    required: true
  }
});
Builder.createAndAttachToType(InstrumentSummary);
/**
 * --
 * @desc BankAccountSummary is a simplified version of the BankAccount model that's suitable
 * for front-end use.
 * --
 *
 * SOURCE BankAccountSummary @ squareup/capital/servicing/instruments/models.proto at 33:1
 */
export const BankAccountSummary = $root.lookupType('squareup.capital.servicing.instruments.models.BankAccountSummary');
fixType(BankAccountSummary, {
  accountNumberSuffix: {
    required: true
  }
});
Builder.createAndAttachToType(BankAccountSummary);